export default import.meta.ROLLDOWN_FILE_URL_05HJvR09HtRmI6I4z21tcw